import { ApplicationError } from '../domain/errors';

import type { MessageKey } from './messages';
import type { Translate } from './types';
import type { ApplicationErrorCode } from '../domain/errors';

const errorMessageKeys: Readonly<Record<ApplicationErrorCode, MessageKey>> = {
    canvasUnavailable: 'error.canvas',
    fileReadFailed: 'error.fileRead',
    imageLoadFailed: 'error.imageLoad',
    invalidFile: 'error.invalidFile',
    invalidScaleSteps: 'error.invalidScaleSteps',
    invalidUrl: 'error.invalidUrl',
    modelLoadFailed: 'error.modelLoad',
    referenceNotFound: 'error.referenceNotFound',
    referenceRequired: 'error.referenceRequired',
    unsupportedProtocol: 'error.protocol',
    unknownModel: 'error.unknownModel',
    videoLoadFailed: 'error.videoLoad',
};

export function translateError(error: unknown, translate: Translate, fallback: MessageKey): string {
    return error instanceof ApplicationError
        ? translate(errorMessageKeys[error.code], error.values)
        : translate(fallback);
}
